import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Pagination,
  Box,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FriendInfoCard from "../../components/FriendInfoCard/FriendInfoCard";
import { isMobile, isTablet } from "react-device-detect";

const FriendsGrid = ({
  friendsData,
  page,
  totalPages,
  setPage,
  onBlockStatusChange,
  onRemoveFriendChange,
  type,
}) => {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    if (!query) return friendsData;
    const q = query.toLowerCase();
    return friendsData.filter((f) =>
      `${f.firstName} ${f.lastName} ${f.school?.schoolName || ""}`
        .toLowerCase()
        .includes(q)
    );
  }, [friendsData, query]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 2,
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography
          fontSize={isMobile || isTablet ? "0.7rem" : "1rem"}
          opacity={1}
          color="white"
          whiteSpace="nowrap"
        >
          {filtered.length} shown
        </Typography>

        <TextField
          size="small"
          placeholder="Search name or school"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          sx={{
            minWidth: 260,
            "& .MuiOutlinedInput-root": {
              borderRadius: 14,
              background: "rgba(0,0,0,0.3)",
              color: "white",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Grid container spacing={2}>
        {filtered.map((friend) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={friend.id}>
            <FriendInfoCard
              firstName={friend.firstName}
              lastName={friend.lastName}
              socials={friend.socials}
              school={friend.school}
              buttons={
                type === "blocked"
                  ? [{ name: "Unblock", callback: () => onBlockStatusChange(friend.id, false) }]
                  : [
                      { name: "Remove", callback: () => onRemoveFriendChange(friend.id) },
                      { name: "Block", callback: () => onBlockStatusChange(friend.id, true) },
                    ]
              }
            />
          </Grid>
        ))}
      </Grid>

      {filtered.length > 0 && (
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, v) => setPage(v)}
          sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}
        />
      )}
    </>
  );
};

FriendsGrid.propTypes = {
  friendsData: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  onBlockStatusChange: PropTypes.func.isRequired,
  onRemoveFriendChange: PropTypes.func,
  type: PropTypes.string.isRequired,
};

export default FriendsGrid;
